// extracted by mini-css-extract-plugin
export default {"sampleProjects":"SampleProjectsTab_sampleProjects__AVjWR"};